import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faRecycle } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import PurgeProjectPopup from "./PurgeProjectPopup";
import { usePurgeProject } from "../queries/use-purge-project";
import { useLanguage } from "../context/LanguageContext";
import { FetchContext } from "../context/FetchContext";

export const ExportButton = ({ projectId, version }) => {
  const { languages } = useLanguage();
  const fetchContext = useContext(FetchContext);

  const exportExcel = async () => {
    const { data } = await fetchContext.authAxios.get(
      `/projects/${projectId}/versions/${version}/keys`
    );
    const all = [["key", ...languages.map((l) => l.iso)]];

    data.forEach((d) => {
      const { name, translations } = d;
      const row = [];
      row.push(name);
      languages
        .map((l) => l.id)
        .forEach((lang) => {
          const t = translations.find((t) => t.languageId === lang);
          row.push(t?.translation ?? "");
        });
      all.push(row);
    });
    const worksheet = XLSX.utils.aoa_to_sheet(all);
    const wb = XLSX.utils.book_new();
    wb.SheetNames.push("data");
    wb.Sheets.data = worksheet;
    XLSX.writeFile(wb, "out.xlsx");
  };
  return (
    <>
      <button
        type="button"
        className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-blue-500 text-white text-sm font-semibold shadow-sm hover:opacity-95 transition"
        onClick={() => exportExcel()}
      >
        <FontAwesomeIcon className="w-3.5 h-3.5" icon={faFileExport} />
        Export
      </button>
    </>
  );
};
